module.exports = __webpack_public_path__ + "images/花筑pr长图_03.jpg?v=2b18b16f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_03.jpg
 ** module id = 13
 ** module chunks = 1 2
 **/